import React, { useState, useEffect } from 'react';
import { doc, updateDoc, collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { FaTimes, FaCheck } from 'react-icons/fa';
import '../styles/tasksWindow.css';

function TaskWindow({ task, onClose }) {
  const [name, setName] = useState(task.name);
  const [completed, setCompleted] = useState(task.completed);
  const [responsible, setResponsible] = useState(task.responsible || '');
  const [deadline, setDeadline] = useState(task.deadline || '');
  const [users, setUsers] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  // Hent brugere
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersCollection = collection(db, 'users');
        const usersSnapshot = await getDocs(usersCollection);
        const usersData = usersSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setUsers(usersData);
      } catch (error) {
        console.error('Fejl ved hentning af brugere:', error);
      }
    };
    fetchUsers();
  }, []);

  const handleSave = async (changes) => {
    setIsSaving(true);
    try {
      const taskRef = doc(db, 'tasks', task.id);
      await updateDoc(taskRef, {
        ...changes,
        updatedAt: new Date().toISOString()
      });

      // Hvis opgaven markeres som færdig, luk vinduet
      if (changes.completed === true) {
        setTimeout(() => {
          onClose();
        }, 500); // Giv tid til at se "completed" status før vinduet lukker
      }
    } catch (error) {
      console.error('Fejl ved opdatering af opgave:', error);
    } finally {
      setIsSaving(false);
    }
  };

  const toggleStatus = async () => {
    const newStatus = !completed;
    setCompleted(newStatus);
    await handleSave({ completed: newStatus });
  };

  const handleNameChange = async (e) => {
    const newName = e.target.value;
    setName(newName);
    await handleSave({ name: newName });
  };

  const handleResponsibleChange = async (e) => {
    const newResponsible = e.target.value;
    setResponsible(newResponsible);
    await handleSave({ responsible: newResponsible });
  };

  const handleDeadlineChange = async (e) => {
    const newDeadline = e.target.value;
    setDeadline(newDeadline);
    await handleSave({ deadline: newDeadline });
  };

  const getDeadlineStatus = (deadline) => {
    if (!deadline) return null;
    const today = new Date();
    const deadlineDate = new Date(deadline);
    const daysUntilDeadline = Math.ceil((deadlineDate - today) / (1000 * 60 * 60 * 24));
    
    if (daysUntilDeadline < 0) return 'overdue';
    if (daysUntilDeadline <= 3) return 'warning';
    return null;
  };

  const deadlineStatus = getDeadlineStatus(deadline);

  return (
    <>
      <div className="task-window-overlay" onClick={onClose}></div>
      <div className="task-window">
        <button className="close-button" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="task-content">
          <div className="task-header">
            <button
              className={`status-toggle ${completed ? 'completed' : ''}`}
              onClick={toggleStatus}
            >
              <FaCheck />
            </button>
            <input
              type="text"
              value={name}
              onChange={handleNameChange}
              placeholder="Opgave navn"
              className="task-name-input"
            />
          </div>

          <div className="task-details">
            <div className="form-group">
              <label>Ansvarlig</label>
              <select
                value={responsible}
                onChange={handleResponsibleChange}
                className="responsible-select"
              >
                <option value="">Vælg ansvarlig...</option>
                {users.map(user => (
                  <option key={user.id} value={user.id}>
                    {user.name || user.email}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Deadline</label>
              <input
                type="date"
                value={deadline}
                onChange={handleDeadlineChange}
                className={`deadline-input ${deadlineStatus ? `deadline-${deadlineStatus}` : ''}`}
              />
              {deadlineStatus === 'warning' && (
                <span className="deadline-warning">Deadline nærmer sig</span>
              )}
              {deadlineStatus === 'overdue' && (
                <span className="deadline-overdue">Deadline overskredet</span>
              )}
            </div>
          </div>

          {isSaving && <div className="saving-indicator">Gemmer...</div>}
        </div>
      </div>
    </>
  );
}

export default TaskWindow;
